export const TOGGLE_PROGRAM_MEMBERS_MODAL = "TOGGLE_PROGRAM_MEMBERS_MODAL";
export const DISPLAY_MEMBERS_INVITATION = "DISPLAY_MEMBERS_INVITATION";
export const DISPLAY_MEMBERS_MANAGEMENT = "DISPLAY_MEMBERS_MANAGEMENT";
